{{#with handle}}
if ({{ identifier }} == {{ unsetValue }}) begin
  `uvm_fatal(get_type_name(), "Must call {{ setterName }}({{ rootType }} {{ identifier }}){{ ../beforeMessage }}.")
end
{{/with}}
